module.exports = __webpack_public_path__ + "static/media/login-bg.738b6b1b.jpg";